import cssModule from "@vercel/turbopack-next/internal/font/google/cssmodule.module.css?{%22path%22:%22LoadingVeil.jsx%22,%22import%22:%22Noto_Sans_JP%22,%22arguments%22:[{%22weight%22:%22900%22,%22preload%22:false,%22display%22:%22swap%22}],%22variableName%22:%22notoJP%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'Noto Sans JP', 'Noto Sans JP Fallback'",
        fontWeight: 900,
fontStyle: "normal",

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
